import { ComponentPropsWithoutRef, forwardRef } from 'react'
import { buttonVariants } from '@/components/ui/button'
import { InitialsAvatar } from '@/components/ui/initials-avatar'
import { cn } from '@/lib/utils'

type AccountMenuAvatarTriggerProps = ComponentPropsWithoutRef<'button'> & {
  src?: string | null
  colorSeed: string
  alt: string
  avatarClassName?: string
}

/**
 * Icon-sized account menu trigger — `InitialsAvatar` filling an `iconSm` hit target.
 * Do not wrap in `Button`: its `[&_svg]:size-4` rule shrinks BoringAvatar identicons.
 */
export const AccountMenuAvatarTrigger = forwardRef<
  HTMLButtonElement,
  AccountMenuAvatarTriggerProps
>(function AccountMenuAvatarTrigger(
  { src, colorSeed, alt, className, avatarClassName, type = 'button', ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        buttonVariants({ variant: 'ghost', size: 'iconSm' }),
        'rounded-full p-0 overflow-hidden [&_svg]:!size-full [&_svg]:shrink-0',
        className
      )}
      {...props}
    >
      <InitialsAvatar
        src={src}
        colorSeed={colorSeed}
        className={cn('size-full border-0', avatarClassName)}
        alt={alt}
      />
    </button>
  )
})
